import React from 'react';
import '../styles/projects.scss';

const Projects = () => (
  <div className="projects" id="projects">
    <h1>My Projects</h1>
    <div className="projects-container">
      <div className="project">
        <div className="image-container">
          <img src="https://i.imgur.com/p6tNK68.png" alt="Lexus Appointment" />
        </div>
        <h3>Lexus Appointment</h3>
        <p>This is a tablet app where you can make an appointment to test the car, before buying it. Login implementation.</p>
        <div className="technologies">
          <h5>HTML</h5>
          <h5>CSS</h5>
          <h5>Sass</h5>
          <h5>React</h5>
          <h5>Redux</h5>
          <h5>Ruby on Rails</h5>
          <h5>SQL</h5>
        </div>
        <div className="links">
          <a href="https://try-lexus.web.app/"><i className="fas fa-globe" /> Live Demo</a>
          <a href="https://github.com/NaguiHW/try-lexus"><i className="fab fa-github" /> Frontend</a>
          <a href="https://github.com/NaguiHW/try-lexus-api" target="_blank" rel="noopener noreferrer"><i className="fab fa-github" /> Backend</a>
        </div>
      </div>
      <div className="project">
        <div className="image-container">
          <img src="https://i.imgur.com/y2hd4AF.png" alt="Bookstore" />
        </div>
        <h3>Bookstore</h3>
        <p>This is a website where You can add books that you are reading, filter by category and delete some books.</p>
        <div className="technologies">
          <h5>HTML</h5>
          <h5>CSS</h5>
          <h5>Sass</h5>
          <h5>React</h5>
          <h5>Redux</h5>
          <h5>Jest</h5>
        </div>
        <div className="links">
          <a href="https://bookstore-467b1.web.app/" target="_blank" rel="noopener noreferrer"><i className="fas fa-globe" /> Live Demo</a>
          <a href="https://github.com/NaguiHW/bookstore" target="_blank" rel="noopener noreferrer"><i className="fab fa-github" /> Code</a>
        </div>
      </div>
      <div className="project">
        <div className="image-container">
          <img src="https://i.imgur.com/sdoYOdO.png" alt="Todo App" />
        </div>
        <h3>To Do App</h3>
        <p>This is a to do app where you can create a to do project, add, delete and modify every task.</p>
        <div className="technologies">
          <h5>HTML</h5>
          <h5>CSS</h5>
          <h5>Javascript</h5>
          <h5>NodeJS</h5>
        </div>
        <div className="links">
          <a href="https://raw.githack.com/NaguiHW/to-do-list/release/dist/index.html" target="_blank" rel="noopener noreferrer"><i className="fas fa-globe" /> Live Demo</a>
          <a href="https://github.com/NaguiHW/to-do-list" target="_blank" rel="noopener noreferrer"><i className="fab fa-github" /> Code</a>
        </div>
      </div>
      <div className="project">
        <div className="image-container">
          <img src="https://i.imgur.com/S0AsHjW.png" alt="Fumigadora Olsan" />
        </div>
        <h3>Fumigadora Olsan</h3>
        <p>This is a website that I created for a fumigation company. You can see all of the information of the company. It is responsive.</p>
        <div className="technologies">
          <h5>HTML</h5>
          <h5>CSS</h5>
          <h5>Sass</h5>
          <h5>React</h5>
        </div>
        <div className="links">
          <a href="https://fumigadora-olsan.web.app/" target="_blank" rel="noopener noreferrer"><i className="fas fa-globe" /> Live Demo</a>
        </div>
      </div>
    </div>
  </div>
);

export default Projects;
